export const eloquaParams = {
    url: larry.eloquaParams.url,
    siteId: larry.eloquaParams.siteId,
};
export const formHiddenFields = {
    myContent: `<input type="hidden" name="elqFormName" value="Global_MyContent_SignUp_Form">
    <input type="hidden" name="elqSiteID" value="${eloquaParams.siteId}">
    <input type="hidden" name="leadHookLong" value="${window.location.origin}${window.location.pathname}">
    <input type="hidden" name="leadSourceMostRecent" value="Pre-Surgery Website">`,
};
export const countries = larry.countryDropdown;
export const roleList = `
<select id="typeOfLead" name="typeOfLead" required>
    <option value="Patient" selected>${larry.strings.roleList.patient}</option>
    <option value="Relative">${larry.strings.roleList.relative}</option>
    <option value="HCP">${larry.strings.roleList.professional}</option>
    <option value="Other">${larry.strings.roleList.other}</option>
</select>`;
let currentDate = new Date();
let dateString = currentDate.toISOString();
dateString = dateString.split('T')[0];
dateString = dateString.split('-').join('/');
export const marketingConsent = `
<label class="consent">
    <input type="checkbox" name="marketingConsent" value="Yes" required />
    <span class="consent-text">${larry.strings.marketingConsent.consentText}</span>
    <input type="hidden" name="originalMarketingConsentDate" value="${dateString}" />
</label>`;
export const sendChapterForm = `
<div class="wm-popup wm-popup__backdrop -show">
<div class="wm-popup__container -wide -green">
    <a href="#" class="wm-popup__close">${larry.strings.common.close}</a>
    <div class="wm-popup__sendChapter">
        <h2 class="wm-popup__sendChapterHeading">${larry.strings.common.signUpHere}</h2>
        <form action="${eloquaParams.url}" method="post" class="wm-form__signup" data-form="sendFirstContent">
            <div class="row">
                <div class="col-12 col-sm-6">    
                    <input type="text" name="firstname" id="firstname" required placeholder="${larry.strings.common.firstName}*" />
                </div>
                <div class="col-12 col-sm-6">    
                    <input type="text" name="lastname" id="lastname" required placeholder="${larry.strings.common.lastName}*" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">    
                    <input type="email" name="email" id="email" required placeholder="${larry.strings.common.email}*" inputmode="email" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">    
                    ${countries}
                </div>
            </div>
            <div class="row">
                <div class="col-12">    
                    ${marketingConsent}
                </div>
            </div>

            <div class="row wm-form__submitRow">
                <div class="col-12 wm-form__submitColumn">    
                    <input class="-disabled" type="submit" value="${larry.strings.common.send}" />
                </div>
            </div>
            ${formHiddenFields.myContent}
        </form>
    </div>
    <div class="success">
    </div>
</div>
</div>`;
export const sendChapterFormSecond = `
<div class="wm-popup wm-popup__backdrop -show">
<div class="wm-popup__container -wide -green">
    <a href="#" class="wm-popup__close">${larry.strings.common.close}</a>
    <div class="wm-popup__sendChapter">
        <h2 class="wm-popup__sendChapterHeading">${larry.strings.common.signUpHere}</h2>
        <form action="${eloquaParams.url}" method="post" class="wm-form__signup" data-form="sendSecondContent">
            <div class="row">
                <div class="col-12 col-sm-6">    
                    <input type="text" name="firstName" id="firstname" required placeholder="${larry.strings.common.firstName}*" inputmode="text" />
                </div>
                <div class="col-12 col-sm-6">    
                    <input type="text" name="lastName" id="lastname" required placeholder="${larry.strings.common.lastName}*" inputmode="text" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">    
                    <input type="email" name="emailAddress" id="email" required placeholder="${larry.strings.common.email}*" inputmode="email" />
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6">    
                    ${countries}
                </div>
                <div class="col-12 col-sm-6">    
                    <input type="text" name="zipPostal" id="zipcode" required placeholder="${larry.strings.common.zipCode}*" inputmode="text" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">    
                    ${roleList}
                </div>
            </div>
            <div class="row wm-form__dateOfSurgery">
                <div class="col-12">    
                    <input type="text" name="dateofSurgery1" id="date-of-surgery" placeholder="${larry.strings.common.dateOfSurgery}" inputmode="none" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">    
                    ${marketingConsent}
                </div>
            </div>

            <div class="row wm-form__submitRow">
                <div class="col-12 wm-form__submitColumn">    
                    <input class="-disabled" type="submit" value="${larry.strings.common.send}" />
                </div>
            </div>
            ${formHiddenFields.myContent} 
        </form>
    </div>
    <div class="success">
    </div>
</div>
</div>`;
export const signupForm = `
<div class="wm-popup wm-popup__backdrop -show">
<div class="wm-popup__container -wide -green">
    <a href="#" class="wm-popup__close">${larry.strings.common.close}</a>
    <div class="wm-popup__signupForm">
        <h2>${larry.lang == 'en' ? larry.strings.common.connectYourEmail : larry.strings.common.signUpHere}</h2>
        <form action="${eloquaParams.url}" method="post" class="wm-form__signup" data-form="myContent">
            <div class="row">
                <div class="col-12 col-sm-6">    
                    <input type="text" name="firstName" id="firstName" required placeholder="${larry.strings.common.firstName}*" />
                </div>
                <div class="col-12 col-sm-6">    
                    <input type="text" name="lastName" id="lastName" required placeholder="${larry.strings.common.lastName}*" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">    
                    <input type="email" name="emailAddress" id="emailAddress" required placeholder="${larry.strings.common.email}*" inputmode="email" />
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6">    
                    ${countries}
                </div>
                <div class="col-12 col-sm-6">    
                    <input type="text" name="zipPostal" id="zipPostal" required placeholder="${larry.strings.common.zipCode}*" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">    
                    ${roleList}
                </div>
            </div>
            <div class="row">
                <div class="col-12">    
                    ${marketingConsent}
                </div>
            </div>
            ${formHiddenFields.myContent} 
            <div class="row wm-form__submitRow">
                <div class="col-12 wm-form__submitColumn">    
                    <input class="-disabled" type="submit" value="${larry.strings.common.send}" />
                </div>
            </div>
        </form>
    </div>
    <div class="success">
    </div>
</div>
</div>`;
export const verifyEmailForm = `
<div class="wm-popup wm-popup__backdrop -show">
<div class="wm-popup__container -normal -green">
    <a href="#" class="wm-popup__close">${larry.strings.common.close}</a>
    <div class="wm-popup__signupForm">
        <h2>${larry.strings.common.verifyYourEmail}</h2>
        <form action="" method="post" class="wm-form__verify">
            <div class="row">
                <div class="col-12">    
                    <input type="email" name="email" id="email" required placeholder="${larry.strings.common.email}*" inputmode="email" />
                </div>
            </div>
            
            <div class="row text-center wm-form__submitRow">
                <div class="col-12 wm-form__submitColumn">    
                    <input type="submit" name="submit" id="submit" value="${larry.strings.common.sendCode}" />
                </div>
            </div>
        </form>
    </div>
</div>
</div>`;
export const verifyCodeForm = `
<div class="wm-popup wm-popup__backdrop -show">
<div class="wm-popup__container -normal -green">
    <a href="#" class="wm-popup__close">${larry.strings.common.close}</a>
    <div class="wm-popup__signupForm">
        <h2>${larry.strings.common.checkEmail}</h2>
        <form action="" method="post" class="wm-form__verificationCode">
            <div class="row">
                <div class="col-12">    
                    <input type="text" name="vcode" id="vcode" minlength="6" maxlength="6" pattern="[a-zA-Z]*" required placeholder="${larry.strings.common.verificationCode}" />
                </div>
            </div>
            
            <div class="row text-center">
                <div class="col-12">    
                    <input type="submit" name="submit" class="submitVerificationCode" value="${larry.strings.common.verify}" />
                </div>
            </div>
        </form>
    </div>
</div>
</div>`;
export const initialStarContentPopup = `
<div id="savedContentPopupNew" class="wm-popup__savedContent new -show">
        <div class="wm-popup__savedContentInner">
            <div class="wm-popup__savedContentTop">
                <div class="wm-popup__savedContentCloseButton">
                    <i class="far fa-times"></i>
                </div>
                <i class="fal fa-bookmark"></i>
                <h5>${larry.strings.initialStarContentPopup.connectEmailToStarContent}</h5>
                <p class="wm-popup__savedContentConnectList">${larry.strings.initialStarContentPopup.connectEmailToStarList}</p>
                <a href="#" class="wm-button connectEmail popupSignup">${larry.strings.initialStarContentPopup.connectYourEmail}</a>
            </div>
            <div class="wm-popup__savedContentBottom">
                <h5>${larry.strings.initialStarContentPopup.alreadyConnected}</h5>
                <p>${larry.strings.initialStarContentPopup.ifYouHaveAlready}</p>
                <a href="#" class="wm-link -arrowLink -colorRed popupVerify">${larry.strings.initialStarContentPopup.verifyMyEmail}</a>
            </div>
        </div>
</div>`;
export const linkSentPopup = `
<div class="wm-popup wm-popup__backdrop -show">
<div class="wm-popup__container -normal -white">
    <!--<a href="#" class="wm-popup__close">${larry.strings.common.close}</a>-->
    <div class="wm-popup__content">
        <h2 class="icon-checkmark">${larry.strings.common.sentLink}</h2>
        <a href="#" class="wm-popup__secondaryClose closeTrigger wp-block-button__link">${larry.strings.common.continueBrowsing}</a>
    </div>
</div>
</div>`;
